import { GET_GROUPS, SET_GROUPS } from '../actions/actionTypes';

const initialState = {
  list: [],
  isLoading: false,
  isLoaded: false
};

const groupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GROUPS:
      return { ...state, isLoading: true };
    case SET_GROUPS:
      return {
        ...state,
        list: action.groups,
        isLoaded: true,
        isLoading: false
      };
    default:
      return state;
  }
};

export default groupsReducer;
